
<div class="container">
    <div class="row"> 
        <p>Систему поштової індексації України побудовано з урахуванням територіальної належності населених пунктів до адміністративних утворень України на основі п’ятизначної структури індексу. </p>
        <p>П’ятизначна поштова індексація дозволяє зробити процеси сортування кореспонденції більш якісними, простими, а також сприяє прискоренню доставки пошти до адресата. </p>
        <h4>Загальні вимоги написання адреси на конвертах</h4>
        <p>У лівому верхньому кутку потрібно вказати адресу відправника й індекс у такому порядку:</p>
        <ul>                
            <li>прізвище, ім’я, по батькові;</li>
            <li>вулиця, номер будинку, квартири;</li>
            <li>назва населеного пункту, району, області;</li>
            <li>поштовий індекс;</li>
            <li>країна призначення (для міжнародних відправлень).</li>
        </ul>
    
        <p>У правому нижньому кутку слід зазначити адресу одержувача та його індекс у такому ж порядку.</p>
        <a class="link-grey" href="https://www.ukrposhta.ua/ua/zrazky-oformlennia-blankiv-ta-typovi-dokumenty" >Правила та зразки підписання поштових відправлень</a>
        
        <div class="buttonsContainer " >
        

            <download-button class="  " label='Перелік поштових індексів' 
                link="https://www.ukrposhta.ua/files/shares/out/postindex.zip" ></download-button>
            <download-button class="  " label='Перелік відділень поштового зв’язку' 
                link="https://www.ukrposhta.ua/files/shares/out/postvpz.zip" ></download-button>
            <download-button class="  " label='Довідник поштових адрес' 
                link="https://www.ukrposhta.ua/files/shares/out/houses.zip" ></download-button>
            <download-button class="  " label='Довідник поштових адрес і пунктів сортування пошти' 
                link="https://www.ukrposhta.ua/files/shares/out/houses_2.zip" ></download-button>
            <download-button class="  " label='Directory of postal addresses (eng)' 
                link="https://www.ukrposhta.ua/files/shares/out/houses_en.zip" ></download-button>
            <download-button class="  " label='List of post offices (eng)' 
                link="https://www.ukrposhta.ua/files/shares/out/postvpz_en.zip" ></download-button>
            
        </div>

        <!-- <div class="buttonsContainer " >
        

            <download-button class="  " label='Перелік поштових індексів' 
                link="http://services.ukrposhta.com/postindex/upload/postindex.zip" ></download-button>
            <download-button class="  " label='Перелік відділень поштового зв’язку' 
                link="http://services.ukrposhta.com/postindex/upload/postvpz.zip" ></download-button>
            <download-button class="  " label='Довідник поштових адрес' 
                link="http://services.ukrposhta.com/postindex_new/upload/houses.zip" ></download-button>
            <download-button class="  " label='Довідник поштових адрес і пунктів сортування пошти' 
                link="http://services.ukrposhta.com/postindex_new/upload/houses_2.zip" ></download-button>
            <download-button class="  " label='Довідник поштових адрес (eng)' 
                link="http://services.ukrposhta.com/postindex_new/upload/houses_en.zip" ></download-button>
            <download-button class="  " label='Перелік відділень поштового зв’язку (eng)' 
                link="http://services.ukrposhta.com/postindex_new/upload/postvpz_en.zip" ></download-button>
            
        </div> -->

        <!--<div class="buttonsContainer " >
        
            <download-button class="  " label='Перелік поштових індексів' 
                link="https://ok.ukrposhta.ua/doc/zip/Perelik_poshtovyx_indeksiv.zip" ></download-button>
            <download-button class="  " label='Перелік відділень поштового зв’язку' 
                link="https://ok.ukrposhta.ua/doc/zip/Perelik_vpz.zip" ></download-button>
            <download-button class="  " label='Довідник поштових адрес' 
                link="https://ok.ukrposhta.ua/doc/zip/Dovidnyk_poshtovyx_adres.zip" ></download-button>
            <download-button class="  " label='Довідник поштових адрес і пунктів сортування пошти' 
                link="https://ok.ukrposhta.ua/doc/zip/Dovidnyk_poshtovyx_adres_i_punktiv_sortuvannya_poshty.zip" ></download-button>
                <download-button class="  " label='Довідник поштових адрес (eng)' 
                link="https://ok.ukrposhta.ua/doc/zip/Dovidnyk_poshtovyx_adres_en.zip" ></download-button>
            <download-button class="  " label='Перелік відділень поштового зв’язку (eng)' 
                link="https://ok.ukrposhta.ua/doc/zip/Perelik_vpz_en.zip" ></download-button>
            
        </div>-->
        


    </div>
</div>